/* eslint-disable */
import React, {useEffect} from "react";
import Button from "@material-ui/core/Button";
import styles from "./SelectTag.module.css";
import {FormControl, InputLabel, FilledInput, InputAdornment, createStyles, makeStyles, Theme, Backdrop, Collapse , Modal, Checkbox, FormControlLabel} from "@material-ui/core";
import Search from "@material-ui/icons/Search";
import {getTagList} from "../../common/video/VideoActions";
import {useDispatch, useSelector} from "react-redux";
import {AppState} from "../../root/RootReducer";
import CheckboxCheckedIcon from "../../common/components/images/CheckboxCheckedIcon";
import CheckboxIcon from "../../common/components/images/CheckboxIcon";
import useResponsive from "../../common/useResponsive";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        searchTitle: {
            fontSize: "16px"
       },
        searchInput: {
            height: "55px",
            fontSize: "20px",
            borderRadius: "3px"
       },
        searchButton: {
            fontSize: "1rem",
            borderRadius: "5px",
            marginRight: "15px",
            backgroundColor: "var(--red)",
            "&:hover": {
                backgroundColor: "rgb(193, 0, 25)"
           }
       },
        newTagButton: {
            fontSize: "1rem",
            borderRadius: "5px",
            backgroundColor: "var(--red)",
            "&:hover": {
                backgroundColor: "rgb(193, 0, 25)"
           }
       },
        modal: {
            width: "400px",
            marginLeft: "calc((100vw - 800px) / 2 + 380px)",
            marginTop: "calc((100vh - 450px) / 2 + 330px)"
       },
        modalTablet: {
            width: "300px",
            marginLeft: "calc((100vw - 700px) / 2 + 375px)",
            marginTop: "calc((100vh - 350px) / 2 + 230px)"
        },
        modalMobile: {
            width: "300px",
            marginLeft: "45px",
            marginTop: "calc((100vh - 350px) / 2 + 230px)"
        },
        paper: {
            backgroundColor: theme.palette.background.paper
       },
        addButton: {
            fontSize: "1rem",
            borderRadius: "5px"
       }
   })
);

interface SelectTagProps {
    /* モーダル表示切り替え */
    in: boolean;
    // モーダル閉じる
    onClose?: () => void;
    tagList: string[];
    setTagList: (tagList: string[]) => void;
    setIsSaved?: (flg: boolean) => void;
}

const SelectTag = React.forwardRef<HTMLDivElement, SelectTagProps>(function SelectTag(props, ref) {
    const {onClose, tagList, setTagList, setIsSaved} = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const { isDesktop, isTablet } = useResponsive();
    const [displaySkillTag, ChangeDisplaySkillTag] = React.useState<string[]>([]);
    const [searchSkill, ChangeSearchSkill] = React.useState<string[]>([]);
    const [isLimitTag, ChangeLimitTag] = React.useState(false);
    const [isLimitAddTag, ChangeLimitAddTag] = React.useState(false);
    const {tags} = useSelector(({video}: AppState) => video);
    const [open, setOpen] = React.useState(false);
    const [newTag, setNewTag] = React.useState<string>("");
    const [newTagList, setNewTagList] = React.useState<string[]>(tagList);
    const [searchKey, setSearchKey] = React.useState("");

    const handleNewTagModal = () => {
        setOpen(true);
        setNewTag(searchKey);
   };

    const handleClose = () => {
        setOpen(false);
        setNewTag("");
   };

    const handleConditionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchKey(event.currentTarget.value.trim());
        const input = event.currentTarget.value.trim().split(/\s+/);
        if (input.length > 0 && input[0] !== "") {
            dispatch(getTagList(input));
            ChangeSearchSkill(input);
       } else {
            dispatch(getTagList([]));
            ChangeSearchSkill([]);
       }
        ChangeDisplaySkillTag([]);
   };

    const handleTagChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setNewTag(event.currentTarget.value);
   };

    const handleTagKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter" && (newTag || searchKey)) {
            handleNewTag();
       }
   };

    const handleAddTag = () => {
        if (onClose) {
            setTagList(newTagList);
            if (setIsSaved) {
                setIsSaved(false);
           }
            onClose();
       }
   };

    const handleNewTag = () => {
        const addKey = searchKey !== newTag && newTag !== "" ? newTag : searchKey;
        if (onClose) {
            if (!newTagList.includes(addKey)) {
                setTagList([...newTagList, addKey]);
                if (setIsSaved) {
                    setIsSaved(false);
               }
           }
            onClose();
       }
   };

    const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
        let tempList = newTagList;
        if (!event.currentTarget.checked) {
            tempList = newTagList.filter(v => v !== event.currentTarget.name);
       } else {
            tempList = newTagList.concat(event.currentTarget.name);
       }
        setNewTagList(tempList);
   };


    useEffect(() => {
        dispatch(getTagList([]));
   }, [dispatch]);

    // 検索していないときは、新規追加したタグを合わせて表示させる。検索時はフィルター結果を表示させる。
    useEffect(() => {
        console.log("displaySkillTag更新");
        ChangeDisplaySkillTag([]);
        const tmpTags: string[] = [];
        tags.map((row)=>(
            tmpTags.push(row.tag)
        ));
        if(searchSkill.length === 0){
            ChangeDisplaySkillTag(tagList.concat(tmpTags.filter(tag => !tagList.includes(tag))));
            console.log(displaySkillTag);
       }else{
            ChangeDisplaySkillTag(tmpTags);
       }
    // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [tagList, tags]);

    // タグ数制限
    useEffect(() => {
        if(newTagList.length > 5){
            ChangeLimitTag(true);
       }
        else{
            ChangeLimitTag(false);
       }
   }, [newTagList]);
    // 追加タグ数制限
    useEffect(() => {
        if(newTagList.length > 4){
            ChangeLimitAddTag(true);
       }
        else{
            ChangeLimitAddTag(false);
       }
   }, [newTagList]);

    return (
        <>
            <div className={styles.root}>
                <div className={styles.conditionArea}>
                    <FormControl fullWidth variant="filled" color="secondary">
                        <InputLabel htmlFor="searchInput" className={classes.searchTitle}>
                            検索したいタグを入力
                        </InputLabel>
                        <FilledInput
                            id="searchInput"
                            onChange={handleConditionChange}
                            startAdornment={
                                <InputAdornment position="start">
                                    <Search color="secondary" style={{color: "var(--red)"}}/>
                                </InputAdornment>
                           }
                            autoComplete={"off"}
                            className={classes.searchInput}
                        />
                    </FormControl>
                </div>
                <div className={styles.tagArea}>
                    {
                        displaySkillTag.map((item, index) => (
                            <FormControlLabel
                                key={item}
                                control={
                                    <Checkbox
                                        icon={<div className={styles.checkedIcon}><CheckboxIcon /></div>}
                                        checkedIcon={<div className={styles.checkedIcon}><CheckboxCheckedIcon /></div>}
                                        name={item}
                                        checked={newTagList.includes(item)}
                                        onChange={handleCheck}
                                    />
                               }
                                label={item}
                                className={styles.tagCheckBox}
                            />
                        )
                        )
                   }
                </div>
                <div className={styles.btnArea}>
                    <div style={{visibility: isLimitTag ? "visible": "hidden"}} className={styles.limitAttention}>
                        <p style={{color:"var(--red)", fontSize:"15px"}}>※登録できるタグは5件までです。</p>
                    </div>
                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.searchButton}
                        onClick={handleAddTag}
                        disabled={isLimitTag}
                    >
                        Tag追加
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        className={classes.newTagButton}
                        onClick={handleNewTagModal}
                        disabled={isLimitAddTag}
                    >
                        新規Tag作成
                    </Button>
                </div>

                <Modal
                    className={isDesktop ? classes.modal : isTablet ? classes.modalTablet : classes.modalMobile}
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500
                   }}
                >
                    <Collapse in={open}>
                        <div className={classes.paper}>
                            <div className={styles.addTagArea}>
                                <FormControl fullWidth variant="filled" color="secondary">
                                    <InputLabel htmlFor="newTagInput" className={classes.searchTitle}>
                                        新規Tag名入力
                                    </InputLabel>
                                    <FilledInput
                                        id="newTagInput"
                                        onChange={handleTagChange}
                                        onKeyPress={handleTagKeyPress}
                                        endAdornment={
                                            <InputAdornment position="end">
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    className={classes.addButton}
                                                    onClick={handleNewTag}
                                                    disabled={newTag.length === 0}
                                                >
                                                    追加
                                                </Button>
                                            </InputAdornment>
                                       }
                                        defaultValue={searchKey}
                                        autoComplete={"off"}
                                        className={classes.searchInput}
                                    />
                                </FormControl>
                            </div>
                        </div>
                    </Collapse >
                </Modal>
            </div>
        </>
    );
});

export default SelectTag;
